export default "__VITE_ASSET__0FpM4tUi__"